/**
 * Which way changes flow between a playlist and one of its sync sources.
 *
 * String values on purpose: this is persisted in playlists.js.gz, and a
 * numeric enum would make the stored file unreadable and fragile to reorder.
 * A source with no direction stored is treated as `Both` - see
 * `sourceDirection` in syncSourceHelpers.
 */
enum SyncDirection {
  /** Additions and removals on either side are mirrored to the other. */
  Both = 'both',
  /** Changes made at the source (f.x. on YouTube) are applied to the Fadila playlist. */
  FromSource = 'fromSource',
  /** Changes made in Fadila are applied at the source. */
  ToSource = 'toSource',
}

export default SyncDirection;
